import React from 'react';
import { compose } from 'redux';
import { FormattedMessage, injectIntl, intlShape } from '../../util/reactIntl';
import { StaticPage, TopbarContainer } from '../../containers';
import {
  LayoutSingleColumn,
  LayoutWrapperTopbar,
  LayoutWrapperMain,
  LayoutWrapperFooter,
  Footer,
  StaticPageHeader,
  NamedLink,
  NamedRedirect,
} from '../../components';
import config from '../../config';
import { articles } from '../../containers/SupportPage/articles';
import classNames from 'classnames';

import css from './TipsSupportPage.module.css';

const TipsSupportPageComponent = props => {
  const { intl, params } = props;
  const { siteTitle } = config;

  const headerTitle = intl.formatMessage({ id: 'TipsSupportPage.headerTitle' });
  const supportLinkText = intl.formatMessage({ id: 'TipsSupportPage.supportLinkText' });
  const currentPageText = intl.formatMessage({ id: 'TipsSupportPage.currentPage' });

  const articleSlug = params.slug;
  const currentArticle = articles.tips.find(s => s.key === articleSlug);

  if (!currentArticle) {
    return <NamedRedirect name="SupportPage" />;
  }

  const { label, html } = currentArticle;
  return (
    <StaticPage
      title={`Support | ${siteTitle}`}
      schema={{
        '@context': 'http://schema.org',
        '@type': 'TipsSupportPage',
        description: 'Support',
        name: 'TipsSupportPage',
      }}
    >
      <LayoutSingleColumn>
        <LayoutWrapperTopbar>
          <TopbarContainer />
        </LayoutWrapperTopbar>

        <LayoutWrapperMain className={css.staticPageWrapper}>
          <StaticPageHeader
            titleClassName={css.headerTitle}
            title={headerTitle}
            currentPage="SupportPage"
          />
          <div className={css.contentWrapper}>
            <div className={css.supportLinks}>
              <NamedLink className={css.supportLink} name="SupportPage">
                {supportLinkText}
              </NamedLink>
              <span className={css.linksSeparator}>/</span>
              <span className={css.currentLink}>{currentPageText}</span>
            </div>
            <div className={css.contentGrid}>
              <ul className={css.categoryArticles}>
                {articles.tips.map((a, index) => {
                  const articleIndex = index + 1;
                  const isActive = a.key === articleSlug;
                  return (
                    <li
                      className={classNames(css.categoryArticle, {
                        [css.categoryArticleActive]: isActive,
                      })}
                    >
                      <NamedLink
                        className={css.categoryArticleLink}
                        name="TipsSupportPage"
                        params={{ slug: a.key }}
                      >
                        {`${articleIndex}. ${a.label}`}
                      </NamedLink>
                    </li>
                  );
                })}
              </ul>
              <div className={css.articleContent}>
                <h2 className={css.articleHeading}>{label}</h2>
                <div className={css.articleText}>{html}</div>
              </div>
            </div>
          </div>
        </LayoutWrapperMain>

        <LayoutWrapperFooter>
          <Footer />
        </LayoutWrapperFooter>
      </LayoutSingleColumn>
    </StaticPage>
  );
};

TipsSupportPageComponent.propTypes = {
  intl: intlShape.isRequired,
};

const TipsSupportPage = compose(injectIntl)(TipsSupportPageComponent);

export default TipsSupportPage;
